import { Fragment } from "react";
import { Grid, Tooltip, Typography } from "@mui/material";

import { Paper } from "../../../components";
import { comingSoonChannels } from "./audienceObjects";
import { colors } from "../../css components/Style";

export default function CampaignActivationComingSoon() {
  return (
    <Fragment>
      <Grid style={{ margin: "20px 0" }} textAlign={"center"}>
        <Typography
          style={{
            background: colors.publicisBlue,
            padding: "10px",
            borderRadius: "10px",
            color: "#fff",
          }}
          variant="h4"
        >
          Campaign Activation Channels - Coming Soon ...
        </Typography>
      </Grid>

      <Paper style={{ padding: "10px 30px" }}>
        <div className="category-channel-container">
          {comingSoonChannels.map((channel, index) => (
            <Tooltip title={channel.channel} key={index}>
              <div className="category-channel-box">
                <img
                  style={{ marginTop: "10px", height: "50px" }}
                  src={channel.image}
                  alt={channel.channel}
                  className="category-image"
                />
                <div className="category-label">{channel.channel}</div>
              </div>
            </Tooltip>
          ))}
        </div>
      </Paper>
    </Fragment>
  );
}
